<template>
    <div class="saas-page linear-page">
        <section class="linear-hero">
            <div>
                <p class="linear-kicker">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span>/</span>
                    <span>{{ trans('auth.change_password') }}</span>
                </p>
                <h1>{{ trans('auth.change_password') }}</h1>
                <p class="linear-copy">Refresh your admin credentials with a short, focused security flow.</p>
            </div>
            <div class="linear-command-card">
                <span class="linear-dot"></span>
                <span>{{ trans('auth.password') }}</span>
                <kbd>Secure</kbd>
            </div>
        </section>

        <section class="linear-card">
            <div class="linear-card__head">
                <div>
                    <span class="linear-label">{{ trans('auth.password') }}</span>
                    <h2>{{ trans('auth.change_password') }}</h2>
                </div>
                <span class="linear-status">Protected</span>
            </div>
            <form @submit.prevent="changePassword" @keydown="passwordForm.errors.clear($event.target.name)">
                <div class="linear-form-grid">
                    <div class="form-group">
                        <label>{{ trans('auth.current_password') }}</label>
                        <input class="form-control linear-input" type="password" value="" v-model="passwordForm.current_password" name="current_password" :placeholder="trans('auth.current_password')" autocomplete="current-password">
                        <show-error :form-name="passwordForm" prop-name="current_password"></show-error>
                    </div>
                    <div class="form-group">
                        <label>{{ trans('auth.new_password') }}</label>
                        <input type="password" name="new_password" class="form-control linear-input" :placeholder="trans('auth.new_password')" v-model="passwordForm.new_password" autocomplete="new-password">
                        <show-error :form-name="passwordForm" prop-name="new_password"></show-error>
                    </div>
                    <div class="form-group">
                        <label>{{ trans('auth.new_password_confirmation') }}</label>
                        <input class="form-control linear-input" type="password" value="" v-model="passwordForm.new_password_confirmation" name="new_password_confirmation" :placeholder="trans('auth.new_password_confirmation')" autocomplete="new-password">
                        <show-error :form-name="passwordForm" prop-name="new_password_confirmation"></show-error>
                    </div>
                </div>
                <div class="linear-actions">
                    <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{ trans('auth.change_password') }}</button>
                </div>
            </form>
        </section>
    </div>
</template>


<script>
    export default {
        components: {},
        data() {
            return {
                passwordForm: new Form({
                    current_password : '',
                    new_password: '',
                    new_password_confirmation: ''
                })
            };
        },
        mounted(){

        },
        methods: {
            changePassword(){
                this.passwordForm.post('/api/change-password')
                    .then(response => {
                        toastr.success(response.message);
                    }).catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getConfig(config){
                return helper.getConfig(config);
            }
        }
    }
</script>

<style scoped>
.linear-page {
    color: #111318;
}

.linear-hero {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(260px, 0.34fr);
    gap: 1.25rem;
    align-items: end;
    margin-bottom: 1rem;
}

.linear-kicker,
.linear-label {
    color: #625cf6;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-kicker {
    display: flex;
    gap: 0.45rem;
    margin-bottom: 0.65rem;
}

.linear-hero h1 {
    margin: 0;
    font-size: clamp(2rem, 4vw, 3rem);
    font-weight: 800;
    letter-spacing: -0.055em;
}

.linear-copy {
    max-width: 42rem;
    margin: 0.75rem 0 0;
    color: #687083;
    line-height: 1.65;
}

.linear-card,
.linear-command-card {
    border: 1px solid #e5e8ef;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 16px 48px rgba(31, 35, 48, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.86);
}

.linear-card {
    max-width: 980px;
    padding: 1.1rem;
}

.linear-command-card {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    min-height: 3.2rem;
    padding: 0.5rem 0.85rem;
    color: #687083;
    font-weight: 600;
}

.linear-command-card kbd {
    margin-left: auto;
    border: 1px solid #e5e8ef;
    border-radius: 7px;
    color: #8b93a7;
    background: #fff;
}

.linear-dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 999px;
    background: #625cf6;
    box-shadow: 0 0 0 4px rgba(98, 92, 246, 0.1);
}

.linear-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}

.linear-card__head h2 {
    margin: 0.35rem 0 0;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.linear-status {
    padding: 0.28rem 0.55rem;
    border: 1px solid rgba(17, 132, 91, 0.16);
    border-radius: 999px;
    color: #11845b;
    font-size: 0.7rem;
    font-weight: 800;
    background: #e8f7f0;
}

.linear-form-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.85rem;
}

.linear-page label {
    color: #485064;
    font-size: 0.78rem;
    font-weight: 700;
}

.linear-input {
    min-height: 42px;
    border-color: #e5e8ef;
    border-radius: 12px;
    background: #fbfcff;
}

.linear-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
}

@media (max-width: 991.98px) {
    .linear-hero,
    .linear-form-grid {
        grid-template-columns: 1fr;
    }
}
</style>
